const COMPONENT_PLAYGROUND_ROUTE = /^\/pages\/components(?:\/|$)/;

export const isComponentPlaygroundRoute = (route: string) =>
  COMPONENT_PLAYGROUND_ROUTE.test(route);

export const shouldApplyPageHeaderOffset = (route: string) =>
  !isComponentPlaygroundRoute(route);

export const shouldFetchAppCsrf = (route: string, isMobileApp: boolean) =>
  isMobileApp && !isComponentPlaygroundRoute(route);
